import React from "react";
import blockThirdPartyIframes from "../../utilities/block-third-party-iframes";

const Content = ({ className, children, ...other }) => {
  return (
    <>
      {children && (
        <div
          className={`content ${className ? className : ""}`}
          dangerouslySetInnerHTML={{
            __html: blockThirdPartyIframes(children),
          }}
          {...other}
        />
      )}
    </>
  );
};

export default Content;
